import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/self-portrait.jpeg";

import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaEnvelope, FaLine, FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>

            <p className="home-about-body">
              <i>
                <b className="purple">
                  Software Engineer | Full-Stack Developer
                </b>
              </i>
              <br />
              <br />
              Passionate about building scalable, efficient web applications, I
              specialize in full-stack development, with expertise in both
              <i>
                <b className="purple"> frontend and backend technologies.</b>
              </i>
              <br />
              <br />
              Throughout my career, I have worked in a variety of environments,
              from very small teams to large teams of up to 20+ members. I have
              also gained experience across a wide range of business
              environments, from early-stage startups to large global
              enterprises, which has enabled me to independently{" "}
              <span className="purple">
                identify requirements, define workloads, and determine the
                people and skills needed to deliver them.
              </span>
              <br />
              <br />
              While I have <span className="purple">single handedly</span> built
              complete systems from the ground up, I particularly enjoy working
              with larger teams. I like knowledge sharing, learning from others,
              and socializing with co-workers in the tech industry and across
              other fields.
              <br />
              <br />I am proficient in core technologies such as{" "}
              <span className="purple">
                JavaScript, Node.js, PHP, HTML, and CSS
              </span>{" "}
              along with additional experience in a range of other technologies
              and frameworks.
              <br />
              You can find more of the technologies I frequently use on the{" "}
              <a className="purple" href="/about">
                about page
              </a>
              , although it doesn't list everything.
              <br />
              <br />
              Most importantly, I make sure the technology used for any solution
              is programmatically sound.
              <br />
              This means following essential coding conventions that ensure
              scalable/maintainable code to develop dynamic, high-performing
              applications, such as{" "}
              <i>
                <b className="purple">
                  reusability, object-oriented programming, database structures,
                  and server configurations.
                </b>
              </i>
              <br />
              <br />
              Whether it's a{" "}
              <span className="purple"> simple portfolio website</span> or an
              <span className="purple"> entire ecosystem</span> with thousands
              of users, multiple languages, different currencies, and banking
              across continents, I take pride in delivering high-quality
              software solutions that align with user needs and business
              objectives.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src={myImg}
                className="img-fluid rounded-circle"
                alt="avatar"
              />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>

            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/niran00"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:niran.millet@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaEnvelope />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://line.me/ti/p/3s3L25gklY"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLine />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/niranmillet/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
            <p>
              Feel free to <span className="purple">contact </span> me
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
